import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import GeoMapSmartSearchEditor from './GeoMapSmartSearchEditor';
import GeoMapToolPalette from './GeoMapToolPalette';
import GeoMapEditor from './GeoMapEditor';
import GeoMapViewer from './GeoMapViewer';
import GeoUSHeatMap from './GeoUSHeatMap';
import { GEO_MAP_VIEW, TABLE_MAP_VIEW } from './GeoMapConstant';
import { EXPORT_FROM_GEOMAPPING } from '../../trackerConstants';
import { exportGeoMap, setExportSpinnerFlag, updateGeoMapLoading } from '../../actions/geoMappingActions';
import { buildGeoMapExportRequest } from '../../util/geomapUtils';

const GeoMapLanding = ({
  studies,
  geoMapStudy,
  getSampleWeighted,
  fetchKPI,
  gridData,
  handlesideBarToggle,
  sideBarChecked,
  updateModuleStudy,
  hideWeightType,
  updateWeightType,
  handleStudyChange,
  handleGeoMapMove,
  baseBtnDisabled,
  targetBtnDisabled,
  removeKPI,
  resetAndUpdateGeoMapData,
  trackerFn,
  exportSpinnerProgressFlag,
  exportSpinnerWarningInfoMsg,
}) => {
  const [showHeatMap, setShowHeatMap] = useState(false);
  const reduxState = useSelector(state => state);
  const { login, study, geomap } = reduxState;
  const dispatch = useDispatch();
  const { geoWeightTypes } = study;
  const {
    BaseDataGridData,
    TargetDataGridData,
    geographicsTableData,
    selectedGeographicsTabIndex,
    originalTitles,
    mapSettings,
  } = geomap;

  const handleHeatMap = value => {
    if (value === GEO_MAP_VIEW) {
      setShowHeatMap(true);
    } else if (value === TABLE_MAP_VIEW && showHeatMap) {
      setShowHeatMap(false);
    }
  };

  const handleExportGeoMap = (fileName, fileType) => {
    const loginData = login.loginResponse.data;
    dispatch(updateGeoMapLoading(true));
    const exportRequest = buildGeoMapExportRequest(
      fileName,
      fileType,
      geoMapStudy,
      geoWeightTypes,
      BaseDataGridData,
      TargetDataGridData,
      geographicsTableData,
      selectedGeographicsTabIndex,
      originalTitles,
      mapSettings,
    );
    // this.setState({ exportInProgress: true });
    // this.props.setExportSpinnerFlag(true);
    trackerFn({ action: EXPORT_FROM_GEOMAPPING });
    exportGeoMap(loginData.uid, loginData.currentAccountId, exportRequest)
      .then(response => response.json())
      .then(response => {
        if (response) {
          window.open(response.data.url, '_self');
        }
      })
      .finally(() => {
        dispatch(updateGeoMapLoading(false));
        // Promise.all(this.setSpinnerFlagAfterExport()).then(() => {
          // this.setState({
          //   exportInProgress: false,
          // });
        // });
      });
  };

  return (
    <div data-test="GeoMapLandingComponent">
      <input
        type="checkbox"
        className="sidebar-left"
        id="sidebar-left-01"
        onChange={handlesideBarToggle}
        checked={sideBarChecked}
      />
      <label className="sidebar-left" htmlFor="sidebar-left-01" />
      <GeoMapToolPalette
        trackerFn={trackerFn}
        sideBarChecked={sideBarChecked}
        exportSpinnerProgressFlag={exportSpinnerProgressFlag}
        exportSpinnerWarningInfoMsg={exportSpinnerWarningInfoMsg}
        showHeatMap={handleHeatMap}
        heatMapView={showHeatMap}
      />
      <div className="width-80 portfolio-crosstab float-left geomapComponent">
        <div className="crosstab-accordion">
          <GeoMapSmartSearchEditor
            studies={studies}
            getSampleWeighted={getSampleWeighted}
            fetchKPI={fetchKPI}
            removeKPI={removeKPI}
            updateModuleStudy={updateModuleStudy}
            geoMapStudy={geoMapStudy}
            hideWeightType={hideWeightType}
            updateWeightType={updateWeightType}
            handleStudyChange={handleStudyChange}
            gridData={gridData}
            handleGeoMapMove={handleGeoMapMove}
            baseBtnDisabled={baseBtnDisabled}
            targetBtnDisabled={targetBtnDisabled}
            resetAndUpdateGeoMapData={resetAndUpdateGeoMapData}
          />
        </div>
        {geoMapStudy !== undefined && (
          <div className="column geomapreport-body">
            <GeoMapEditor />
            {showHeatMap ? (
              <GeoUSHeatMap
                showHeatMap={handleHeatMap}
                handleExportGeoMap={handleExportGeoMap}
              />
            ) : (
              <GeoMapViewer />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

GeoMapLanding.propTypes = {
  studies: PropTypes.instanceOf(Array),
  geoMapStudy: PropTypes.instanceOf(Object),
  getSampleWeighted: PropTypes.func.isRequired,
  fetchKPI: PropTypes.func,
  gridData: PropTypes.instanceOf(Object).isRequired,
  handlesideBarToggle: PropTypes.func.isRequired,
  sideBarChecked: PropTypes.bool,
  updateModuleStudy: PropTypes.func.isRequired,
  hideWeightType: PropTypes.bool,
  handleStudyChange: PropTypes.func.isRequired,
  handleGeoMapMove: PropTypes.func,
  baseBtnDisabled: PropTypes.bool,
  targetBtnDisabled: PropTypes.bool,
  removeKPI: PropTypes.func,
  resetAndUpdateGeoMapData: PropTypes.func,
  updateWeightType: PropTypes.func,
  trackerFn: PropTypes.func,
  exportSpinnerProgressFlag: PropTypes.bool,
  exportSpinnerWarningInfoMsg: PropTypes.bool,
};

const mapStateToProps = ({ login, study, geomap }) => {
  const { geoMapStudy, geoWeightTypes } = study;
  const {
    BaseDataGridData,
    TargetDataGridData,
    geographicsTableData,
    selectedGeographicsTabIndex,
    originalTitles,
    mapSettings,
  } = geomap;

  return {
    login: login.loginResponse.data,
    study: geoMapStudy,
    weightType: geoWeightTypes,
    base: BaseDataGridData,
    target: TargetDataGridData,
    geoMapData: geographicsTableData,
    selectedGeoMapTabIndex: selectedGeographicsTabIndex,
    originalTitles,
    geoMapSettingsData: mapSettings,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setExportSpinnerFlag: bindActionCreators(setExportSpinnerFlag, dispatch),
    setExportSpinnerWarningInfoMsg: bindActionCreators(
      // setExportSpinnerWarningInfoMsg,
      dispatch
    ),
  };
};

GeoMapLanding.defaultProps = {
  hideWeightType: false,
  sideBarChecked: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(GeoMapLanding);
